/* eslint-disable @typescript-eslint/no-non-null-assertion */
/* eslint-disable @typescript-eslint/ban-types */
import { createApi } from '@reduxjs/toolkit/dist/query/react';
import B2ChatClient, { apiResource, b2chatBaseQuery } from '@src/client';

export type GetConversionConfigResponse = ConversionConfig;

export type UpdateConversionConfigRequest = ConversionConfig;

export type ReportConversionRequest = {
  chatId: string;
  type: string;
  origin: string;
  purchase?: {
    currency: string;
    value: number;
  };
};

export type ConversionConfig = {
  manual?: {
    types?: ('LEAD' | 'PURCHASE' | (string & {}))[]; //LEAD OR PURCHASE
    modules?: ('TAGS' | 'AUDIT' | 'CONSOLE' | (string & {}))[]; //TAGS, AUDIT or CONSOLE
  };
  automatic?: {
    types?: ('LEAD' | (string & {}))[]; //LEAD
    modules?: ('DEPARTMENT' | 'FLOWS' | (string & {}))[]; //DEPARTMENT or FLOWS
  };
};

const capiApi = createApi({
  reducerPath: 'capiApi',
  baseQuery: b2chatBaseQuery,
  tagTypes: ['capi'],
  endpoints: builder => ({
    getConversionConfig: builder.query<GetConversionConfigResponse, void>({
      query: () =>
        apiResource(
          B2ChatClient.resources.capi.actions.getConversionsConfig,
          {}
        ),
      providesTags: ['capi'],
      extraOptions: { maxRetries: 1 },
    }),
    updateConversionConfig: builder.mutation<
      void,
      UpdateConversionConfigRequest
    >({
      query: data => {
        if (data.automatic)
          data.automatic = {
            types: data.automatic?.types?.filter(Boolean),
            modules: data.automatic?.modules?.filter(Boolean),
          };

        if (data.manual)
          data.manual = {
            types: data.manual?.types?.filter(Boolean),
            modules: data.manual?.modules?.filter(Boolean),
          };

        return apiResource(
          B2ChatClient.resources.capi.actions.updateConversionsConfig,
          {
            data: {
              ...(data.manual ? { manual: data.manual } : {}),
              ...(data.automatic ? { automatic: data.automatic } : {}),
            },
          }
        );
      },
      invalidatesTags: ['capi'],
      extraOptions: { maxRetries: 1 },
    }),
    reportConvertion: builder.mutation<void, ReportConversionRequest>({
      extraOptions: { maxRetries: 1 },
      query: request =>
        apiResource(B2ChatClient.resources.capi.actions.reportConversion, {
          data: request,
        }),
    }),
  }),
});

export default capiApi;

export const {
  useGetConversionConfigQuery,
  useUpdateConversionConfigMutation,
  useLazyGetConversionConfigQuery,
  useReportConvertionMutation,
} = capiApi;
